import '../core/data-access/legal-entity.data-access.js';
import "../core/data-access/routing-code.data-access";

import angular from 'angular';
import _ from 'lodash';

(function () {
    'use strict';
    angular.module('app.principal').factory('PrincipalSvc', PrincipalSvc);

    /* @ngInject */
    function PrincipalSvc(
        $filter,
        $uiRouterGlobals,
        $sessionStorage,
        CONF,
        PRINCIPAL,
        PrincipalsDA,
        PrincipalDetail,
        PrincipalEpdf,
        PrincipalKiss,
        LegalEntity,
        LegalEntityDA,
        AuditDA,
        SellersDA,
        $q,
        $uibModal,
        LegalEntityGroupUser,
        WorkflowDA
    ) {
        var _principal = null;
        var _admin = null;
        var _principalId = null;
        var _principalEid = null;
        var _princStatus = null;
        var _princBuyersNotifsUnsent = null;
        var _menu = null;

        var exports = {
            // Gestion des données
            getLangs: getLangs,
            getPlateforms: getPlateforms,
            getLadProcess: getLadProcess,
            getMenuItems: getMenuItems,
            setPrincipalId: setPrincipalId,
            getPrincipalId: getPrincipalId,
            getPrincipalEid: getPrincipalEid,
            getPrincipal: getPrincipal,
            setPrincipal: setPrincipal,
            refreshPrincipal: refreshPrincipal,
            getPrincStatus: getPrincStatus,
            getPrincipBuyersNotifsNumber: getPrincipBuyersNotifsNumber,
            refreshPrincipalBuyersNotifsUnsent: refreshPrincipalBuyersNotifsUnsent,
            refreshPrincStatus: refreshPrincStatus,
            searchPrincipals: searchPrincipals,
            searchCompanies: searchCompanies,
            getAdmin: getAdmin,
            setAdmin: setAdmin,
            // Création d'un DO
            getCreatePrincipal: getCreatePrincipal,
            shouldRedirectCreate: shouldRedirectCreate,
            changeCreationStep: changeCreationStep,
            createPrincipal: createPrincipal,
            // Mise à jour du DO
            updatePrincipal: updatePrincipal,
            // Consultation d'un DO
            initMenuConsult: initMenuConsult,
            updateMenuConsult: updateMenuConsult,
            //Gestion de l'espace documentaire du DO
            getDocumentarySpace: getDocumentarySpace,
            updateDocumentarySpace: updateDocumentarySpace,
            deleteDocumentarySpace: deleteDocumentarySpace,
            checkAndSaveDocumentarySpace: checkAndSaveDocumentarySpace,
            // Import sociétés, des fournisseurs et des relation commercialess
            importRef: importRef,
            // Envoie des notifications
            sendNotifications: sendNotifications,
            sendBuyersNotifications: sendBuyersNotifications,
            // Liste des DO
            checkDuplicateEid: checkDuplicateEid,
            checkDuplicateAppId: checkDuplicateAppId,
            getLegalEntity: getLegalEntity,
            updateLegalEntity: updateLegalEntity,
            createLegalEntity: createLegalEntity,
            getNewLegalEntity: getNewLegalEntity,
            // Détache une société
            companySignOut : companySignOut,
            // Gestion des templates email
            importEmailTemplate: importEmailTemplate,
            getEmailTemplate: getEmailTemplate,
            searchSellers: searchSellers,
            searchBuyers: searchBuyers,
            getInvitation: getInvitation,
            getBuyerInvitation: getBuyerInvitation,
            searchSellersByNameOrId: searchSellersByNameOrId,
            searchBuyersByNameOrId: searchBuyersByNameOrId,
            searchReports: searchReports,
            downloadReportFile: downloadReportFile,
            getReportFrequencies: getReportFrequencies,
            getInvitationReportErrorFrequencies: getInvitationReportErrorFrequencies,
            getReportWithLink: getReportWithLink,
            getExportInvitationsLinks: getExportInvitationsLinks,
            getSellerListFilter: getSellerListFilter,
            getBuyerListFilter: getBuyerListFilter,
            isCompanyDeletable: isCompanyDeletable,
            deleteCompany: deleteCompany,
            initSellerFilterSessionStorage: initSellerFilterSessionStorage,
            initBuyerFilterSessionStorage: initBuyerFilterSessionStorage,
            isPrincipalDeletable: isPrincipalDeletable,
            deletePrincipal: deletePrincipal,
            getPrincipalListFilter: getPrincipalListFilter,
            getCompanyListFilter: getCompanyListFilter,
            getContainerListFilter: getContainerListFilter,
            setContainerListFilter: setContainerListFilter,
            setCompanyListFilter: setCompanyListFilter,
            setPrincipalListFilter: setPrincipalListFilter,
            initPrincipalListStorage: initPrincipalListStorage,
            searchGroups: searchGroups,
            createGroup: createGroup,
            updateGroup: updateGroup,
            searchUsers: searchUsers,
            saveUser: saveUser,
            getPrincipalById: getPrincipalById,
            isUserSingleAdminFo: isUserSingleAdminFo,
            hasSellerInvited: hasSellerInvited,
            autoCompleteGetAllSubEntityDOPermiter: autoCompleteGetAllSubEntityDOPermiter,
            getSubEntities: getSubEntities,
            getDivisions: getDivisions,
            listCompanies: listCompanies,
            createGroupSubEntity: createGroupSubEntity,
            updateGroupSubEntity: updateGroupSubEntity,
            listPrincipals: listPrincipals,
            checkGisPlatformId: checkGisPlatformId,
            checkGisCompanyDetail: checkGisCompanyDetail,
            createPrincipalAdmin: createPrincipalAdmin,
            hasAcceptedInvitations: hasAcceptedInvitations,
            getWorkflowReferences: getWorkflowReferences,
            getSubEntity: getSubEntity,
            getCgvOfSubEntity: getCgvOfSubEntity,
            getCgvPdf: getCgvPdf,
            uploadCgvPdf: uploadCgvPdf,
            deleteCgvDoc: deleteCgvDoc,
            updateSubEntity: updateSubEntity,
            createSubEntity: createSubEntity,
            getBrand: getBrand,
            exportInvitedBuyersFollowUp: exportInvitedBuyersFollowUp,
            countInvitedBuyersFollowUpNotifiedWithDate: countInvitedBuyersFollowUpNotifiedWithDate,
            getSubEntityRejectionInfo: getSubEntityRejectionInfo,
            getSellerReferentialSendingFrequencies: getSellerReferentialSendingFrequencies,
            exportConfDo: exportConfDo,
            checkImportConfDo: checkImportConfDo,
            canHaveSalesAdmin: canHaveSalesAdmin,
            // Import DO
            importConfDo: importConfDo,
            getAllReferentialsOfPrincipal: getAllReferentialsOfPrincipal,
            saveAllReferentials: saveAllReferentials,
            findReferentialsOfCommunitiesByIds: findReferentialsOfCommunitiesByIds,
            getAllDematPlatforms: getAllDematPlatforms,
            getGroup: getGroup,
            getLegalEntityAndSubEntityForGroup: getLegalEntityAndSubEntityForGroup,
            getGroupColumns: getGroupColumns,
            getGroupData: getGroupData,
            getGroupTitle: getGroupTitle,
            checkAppIdExist: checkAppIdExist,
            getSocFr: getSocFr,
            createOrUpdatePdp:createOrUpdatePdp,
            createOrUpdateSubEntPdp:createOrUpdateSubEntPdp,
            createOrUpdateRoutingCodePdp: createOrUpdateRoutingCodePdp,
            checkFacturXExchangeDirectoryExistence: checkFacturXExchangeDirectoryExistence,
            //OffreApi
            getOffresApi:getOffresApi,
            addOfferApi:addOfferApi,
            getOffresApiForLegalEntity:getOffresApiForLegalEntity,
            //Gestion des lisibles
            downloadClientResourceVersion:downloadClientResourceVersion,
            deleteClientResourceVersion:deleteClientResourceVersion,
            uploadAndDeployClientResource:uploadAndDeployClientResource,
            getClientResourceVersions:getClientResourceVersions,
            hasCommunityHandlingStockSoftware: hasCommunityHandlingStockSoftware,
            //Parametrage acquittements
            getAcquittal: getAcquittal,
            addAcquittal: addAcquittal,
            getLegalEntityContext: getLegalEntityContext,
            addAcquittalForLegalEntity:addAcquittalForLegalEntity,
        };

        return exports;

        ////////////////
        /**
         * Récupération des langues disponibles
         */
        function getLangs() {
            return angular.copy(PRINCIPAL.langs);
        }
        /**
         * Récupération des code pays des sociétés françaises
         */
        function getSocFr() {
            return angular.copy(PRINCIPAL.socFr);
        }
        function hasCommunityHandlingStockSoftware(legalEntityId) {
            return PrincipalsDA.hasCommunityHandlingStockSoftware(legalEntityId);
        }
        /**
         * Récupération de la liste des plateformes
         */
        function getPlateforms() {
            return angular.copy(PRINCIPAL.plateforms);
        }
        /**
         * Récupération des traitement LAD possibles
         */
        function getLadProcess() {
            return angular.copy(PRINCIPAL.ladTypes);
        }

        /**
         * Récupération des item du menu vertical à gauche
         */
        function getMenuItems() {
            return _menu;
        }

        /**
         * Setter identifiant du donneur d'ordre
         */
        function setPrincipalId(id) {
            _principalId = id;
        }

        /**
         * Getter identifiant du donneur d'ordre, si pas en "mémoire" on essaye avec l'état
         */
        function getPrincipalId() {
            if (_principalId) return _principalId;
            if ($uiRouterGlobals.params.id) return $uiRouterGlobals.params.id;
            return null;
        }

        /**
         * Getter identifiant (EID) du donneur d'ordre
         */
        function getPrincipalEid() {
            return _principalEid;
        }

        /**
         * Récupération du principal courrant
         */
        function getPrincipal() {
            return _principal;
        }

        /**
         * Setter donneur d'ordre
         */
        function setPrincipal(principal) {
            _principal = principal;
        }
        /**
         * Récupération de l'admin à créer
         */
        function getAdmin() {
            return _admin;
        }

        /**
         * Setter de l'admin à créer
         */
        function setAdmin(admin) {
            _admin = admin;
        }

        /**
         * Récupération d'un donneur d'ordre sur le serveur
         *
         * @param {Number} id - identifiant du donneur d'ordre
         *
         */
        function refreshPrincipal(id, countries, ladProviders) {
            return PrincipalsDA.getPrincipal(id).then(data => {
                data.detail.setCountry(countries);
                data.epdf.setLadProvider(ladProviders);
                _principal = data;
                _principalEid = data.detail.eid;
                return _principal;
            });
        }

        /**
         * Récupération d'un donneur d'ordre sur le serveur
         *
         * @param {Number} id - identifiant du donneur d'ordre
         *
         */
        function getPrincipalById(id) {
            return PrincipalsDA.getPrincipal(id).then(data => {
                return data;
            });
        }

        /**
         * Permet de vérifier si le DO à un fourinisseur invité qui a accepté l'invitation
         *
         * @param {Number} id - identifiant du donneur d'ordre
         *
         */
        function hasAcceptedInvitations(id) {
            return PrincipalsDA.hasAcceptedInvitations(id);
        }

        /**
         * Getter pour le status du principal (permet l'affichage du menu)
         */
        function getPrincStatus() {
            return _princStatus;
        }

        /**
         * Getter pour le nombre de notifs non envoyées
         */
        function getPrincipBuyersNotifsNumber() {
            return _princBuyersNotifsUnsent;
        }

        /**
         * Récupération du status depuis le serveur
         */
        function refreshPrincStatus(id) {
            return PrincipalsDA.getStatus(id).then(function (data) {
                _princStatus = data;
                _refreshMenuStat();
                return _princStatus;
            });
        }

        /**
         * Récupération du nombre de notifs non envoyées depuis le serveur
         */
        function refreshPrincipalBuyersNotifsUnsent(id) {
            return PrincipalsDA.getUnsentNotifsNumber(id).then(function (data) {
                _princBuyersNotifsUnsent = data;
                _refreshMenuStat();
                return _princBuyersNotifsUnsent;
            });
        }

        /**
         * Initialisation d'un nouveau donneur d'ordre
         */
        function getCreatePrincipal() {
            _menu = angular.copy(PRINCIPAL.menuCreate);
            _principal = {
                detail: new PrincipalDetail(),
                kiss: new PrincipalKiss(),
                epdf: new PrincipalEpdf(),
            };
            return _principal;
        }

        /**
         * Redirection vers la première page de création si on n'a pas pour
         * le donneur d'ordre l'identifiant généré par le système.
         */
        function shouldRedirectCreate() {
            return !!(!_principal || !_principal.detail);
        }
        /**
         * Changement des étapes lors de la création
         */
        function changeCreationStep(currentStep, nextStep) {
            var curItem = _.find(_menu, { step: +currentStep });
            var nextItem = _.find(_menu, { step: +nextStep });
            // On passe l'étape précédente à inactive
            curItem.active = false;

            // Affichage des 'tick' si on recule d'étape on enlève le 'tick' de la suivante (dans ce cas la précédente)
            // si on avance on le rajoute dans la courante
            if (currentStep < nextStep) {
                curItem.showOk = true;
            } else if (currentStep > nextStep) {
                nextItem.showOk = false;
            }

            // On enable la nouvelle etape
            nextItem.disabled = false;
            // On passe la nouvelle étape à active
            nextItem.active = true;
        }

        /**
         * Création d'un donneur d'ordre
         *
         * @param {Object} principal - les donneur d'ordre composé d'un PrincipalDetail, un PrincipalKiss et un PrincipalEpdf
         */
        function createPrincipal(principal) {
            return PrincipalsDA.createPrincipal(principal);
        }

        /**
         * Mise à jour d'un donneur d'ordre
         *
         * @param {Object} principal - les donneur d'ordre composé d'un PrincipalDetail, un PrincipalKiss et un PrincipalEpdf
         */
        function updatePrincipal(principal) {
            var deferred = $q.defer();
            PrincipalsDA.updatePrincipal(principal).then(
                function (data) {
                    _principal = data;
                    updateMenuConsult();
                    deferred.resolve(_principal);
                },
                function (error) {
                    if (
                        ['DUPLICATE_TYPE_I_PCP_LGR_NAME', 'DUPLICATE_TYPE_S_PCP_LGR_NAME'].indexOf(error.data.code) !==
                        -1
                    ) {
                        openPrincipalUpdateNotAllowedModal(error.data.code);
                    } else {
                        deferred.reject(error);
                    }
                }
            );
            return deferred.promise;
        }

        // Popup affichée dans le cas où la mise à jour du DO n'est pas possible à cause d'un doublon de nom.
        function openPrincipalUpdateNotAllowedModal(errorCode) {
            $uibModal
                .open({
                    component: 'modalMessage',
                    size: 'lg',
                    resolve: {
                        modalTitle: function () {
                            return 'Enregistrement impossible';
                        },
                        message: () => {
                            return errorCode === 'DUPLICATE_TYPE_I_PCP_LGR_NAME'
                                ? 'error.functional.duplicate_type_i_pcp_lgr_name'
                                : 'error.functional.duplicate_type_s_pcp_lgr_name';
                        },
                    },
                })
                .result.then(
                    function () {},
                    function () {}
                );
        }

        /**
         * Initialisation du menu
         */
        function initMenuConsult(id) {
            _menu = _.map(angular.copy(PRINCIPAL.menuConsult), menuItem => {
                menuItem.link += `({'id': '${id}'})`;
                return menuItem;
            });
        }

        /**
         * Met à jour le menu de gauche.
         */
        function updateMenuConsult() {
            _.map(_menu, menuItem => {
                if (menuItem.id === 'kiss' || menuItem.id === 'epdf') {
                    menuItem.display = !!_principal.detail.profilBuyer;
                } else if (menuItem.id === 'group' || menuItem.id === 'users') {
                    menuItem.display = _principal.detail.isConfigPortail();
                } else if (menuItem.id === 'order-param') {
                    menuItem.display = isDisplayOrderParam();
                } else if (menuItem.id === 'response-param') {
                    menuItem.display = isDisplayResponseParam();
                } else if (menuItem.id === 'recadv-param') {
                    menuItem.display = isDisplayRecAdvParam();
                } else if (menuItem.id === 'desadv-param') {
                    menuItem.display = isDisplayDesAdvParam();
                } else if (menuItem.id === 'sellers') {
                    menuItem.display = _principal.kiss.paramKiss && _principal.detail.profilBuyer;
                } else if (menuItem.id === 'containers') {
                    menuItem.display =
                        _principal.detail.profilBuyer && (_principal.kiss.paramKiss || _principal.epdf.ladProviderEid);
                } else if (menuItem.id === 'client') {
                    menuItem.display = !!_principal.detail.profilSeller;
                } else if (menuItem.id === 'buyers') {
                    menuItem.display = _principal.buyer.paramBuyer;
                } else if (menuItem.id === 'invoice-statements') {
                    menuItem.display = _principal.detail.profilSeller;
                } else if (menuItem.id === 'managing-referential') {
                    menuItem.display = _principal.detail.managingReferential;
                }
            });
        }

        /**
         * Condition d'affichage du menu order-param
         */
        function isDisplayOrderParam() {
            return !!_principal.detail.profilBuyer || !!_principal.detail.orderRe || !!_principal.detail.orderEm;
        }

        /**
         * Condition d'affichage du menu response-param
         */
        function isDisplayResponseParam() {
            return (
                (!!_principal.detail.orderResponseRe && !!_principal.detail.orderEm) ||
                (!!_principal.detail.orderResponseEm && !!_principal.detail.orderRe) ||
                isOrderAndNotConfigPortail()
            );
        }

        /**
         * Condition d'affichage du menu recadv-param
         */
        function isDisplayRecAdvParam() {
            return (
                (!!_principal.detail.orderRecAdvEm && !!_principal.detail.orderEm) ||
                (!!_principal.detail.orderRecAdvRe && !!_principal.detail.orderRe) ||
                isOrderAndNotConfigPortail()
            );
        }

        /**
         * Condition d'affichage du menu desadv-param
         */
        function isDisplayDesAdvParam() {
            return (
                (!!_principal.detail.orderDesAdvRe && !!_principal.detail.orderEm) ||
                ((!!_principal.detail.orderDesAdvEm || !!_principal.detail.orderDisplayDesAdvEm) &&
                    !!_principal.detail.orderRe) ||
                isOrderAndNotConfigPortail()
            );
        }

        function isOrderAndNotConfigPortail() {
            return !_principal.detail.isConfigPortail() && (!!_principal.detail.orderEm || !!_principal.detail.orderRe);
        }

        /**
         * Mise à jour des icones du menu de consultation
         */
        function _refreshMenuStat() {
            // Gestion du nombre de société, nombre de fournisseurs et nombre de fournisseurs non notifiés
            // à mettre à jour à l'initialisation et lors du clique sur les 3 boutons d'imports + sur le bouton
            // notifier
            var compItem = _.find(_menu, { id: 'companies' });
            if (_princStatus && (!_princStatus.nbCompanies || _princStatus.nbCompanies === 0)) {
                compItem.showOk = false;
                compItem.showWarning = true;
            } else {
                compItem.showOk = true;
                compItem.showWarning = false;
            }

            var sellItem = _.find(_menu, { id: 'sellers' });
            if (
                _princStatus &&
                (!_princStatus.nbSellers || _princStatus.nbSellers === 0 || _princStatus.nbSellersWithoutRelations > 0)
            ) {
                sellItem.showOk = false;
                sellItem.showWarning = true;
                sellItem.showNotif = false;
            } else if (_princStatus && _princStatus.nbNotifsNotSent > 0) {
                sellItem.showOk = false;
                sellItem.showWarning = false;
                sellItem.showNotif = true;
            } else {
                sellItem.showOk = true;
                sellItem.showWarning = false;
                sellItem.showNotif = false;
            }
            var buyerItem = _.find(_menu, { id: 'buyers' });
            if (
                _princStatus &&
                (!_princStatus.nbBuyers || _princStatus.nbBuyers === 0 || _princStatus.nbBuyersWithoutRelations > 0)
            ) {
                buyerItem.showOk = false;
                buyerItem.showWarning = true;
                if (_princStatus && _princStatus.nbNotifsNotSentToBuyers > 0) {
                    buyerItem.showNotif = true;
                } else {
                    buyerItem.showNotif = false;
                }
            } else if (_princStatus && _princStatus.nbNotifsNotSentToBuyers > 0) {
                buyerItem.showOk = false;
                buyerItem.showWarning = false;
                buyerItem.showNotif = true;
            } else {
                buyerItem.showOk = true;
                buyerItem.showWarning = false;
                buyerItem.showNotif = false;
            }
        }

        /**
         * Fonction d'import des sociétés, des fournisseurs et des relations commerciales
         */
        function importRef(type, criteria) {
            switch (type) {
                case 'standard-companies':
                    return PrincipalsDA.importStandardCompanies(criteria);
                case 'kiss-companies':
                    return PrincipalsDA.importKissCompanies(criteria);
                case 'epdf-companies':
                    return PrincipalsDA.importEpdfCompanies(criteria);
                case 'sellers':
                    return PrincipalsDA.importSellers(criteria);
                case 'buyers':
                    return PrincipalsDA.importBuyers(criteria);
                case 'relations':
                    return PrincipalsDA.importRelations(criteria);
                case 'buyersrelations':
                    return PrincipalsDA.importBuyersRelations(criteria);
                case 'buyerSubEntitesRelations':
                    return PrincipalsDA.importBuyerSubEntitiesRelations(criteria);

            }
        }

        function getReportWithLink(report, name, principalId) {
            report.name =
                'RPT-' + principalId + '-' + name + '-' + $filter('date')(new Date(), 'dd-MM-yyyy_HH-mm-ss') + '.csv';
            report.link = CONF.apiContext + CONF.apiBaseUrl + '/v1/files/' + report.reportId;
            return report;
        }

        function getExportInvitationsLinks(report) {
            const filesUrl = CONF.apiContext + CONF.apiBaseUrl + '/v1/files/';
            report.fileLink = filesUrl + report.exportInvitationsId;
            report.reportLink = filesUrl + report.reportId;
            return report;
        }

        /**
         * Fonction d'import des templates emails personalisés
         */
        function importEmailTemplate(file, principalId, type) {
            return PrincipalsDA.importEmailTemplate({
                file: file,
                principalId: principalId,
                type: type,
            });
        }

        /*
         * Fonction de récupération du template Email
         */
        function getEmailTemplate(fileName, principalId) {
            return PrincipalsDA.getEmailTemplate({
                fileName: fileName,
                principalId: principalId,
            });
        }

        /**
         * Envoie des notifications pour le donneur d'ordre
         *
         * @param {number} principalId - Identifiant du donneur d'ordre
         */
        function sendNotifications(principalId) {
            return PrincipalsDA.sendNotifications(principalId, angular.lowercase('mail'));
        }

        /**
         * Envoie des notifications pour le donneur d'ordre vers les clients invités
         *
         * @param {number} principalId - Identifiant du donneur d'ordre
         */
        function sendBuyersNotifications(principalId) {
            return PrincipalsDA.sendBuyersNotifications(principalId, angular.lowercase('mail'));
        }

        /**
         * Liste les donneurs d'ordres existants.
         */
        function listPrincipals() {
            return PrincipalsDA.listPrincipals();
        }

        function checkDuplicateEid(principalEid) {
            return PrincipalsDA.checkDuplicateEid(principalEid);
        }

        function checkDuplicateAppId(principalEid) {
            return PrincipalsDA.checkDuplicateAppId(principalEid);
        }

        function checkAppIdExist(appId) {
            return PrincipalsDA.checkAppIdExist(appId);
        }

        function getLegalEntity(principalId, legalEntityId) {
            return PrincipalsDA.getLegalEntity(principalId, legalEntityId);
        }

        function getNewLegalEntity() {
            var legalEntity = new LegalEntity();
            if (_principal != undefined && _principal != null) {
                legalEntity.countryCode = _principal.detail.countryCode;
            }
            return legalEntity;
        }

        function updateLegalEntity(criteria, principalId) {
            return PrincipalsDA.updateLegalEntity(criteria, principalId);
        }

        function createLegalEntity(legalEntity, principalId) {
            return PrincipalsDA.createLegalEntity(legalEntity, principalId);
        }

        function searchPrincipals(searchValue) {
            return PrincipalsDA.searchPrincipals(searchValue);
        }

        function searchCompanies(searchValue) {
            return PrincipalsDA.searchCompanies(searchValue);
        }

        function setPrincipalListFilter(searchValue) {
            $sessionStorage.principalListFilter = searchValue;
        }

        function setCompanyListFilter(searchValue) {
            $sessionStorage.companyListFilter = searchValue;
        }

        function setContainerListFilter(searchValue) {
            $sessionStorage.containerListFilter = searchValue;
        }

        function searchSellers(principalId, searchData) {
            $sessionStorage.sellerListFilter = searchData;
            var filter = searchData.preparBeforeSearch();
            return PrincipalsDA.searchSellers(principalId, filter);
        }

        function searchBuyers(principalId, searchData) {
            $sessionStorage.buyerListFilter = searchData;
            var filter = searchData.preparBeforeSearch();
            return PrincipalsDA.searchBuyers(principalId, filter);
        }

        function getInvitation(invitationId) {
            return PrincipalsDA.getInvitation(invitationId);
        }

        function getBuyerInvitation(invitationId) {
            return PrincipalsDA.getBuyerInvitation(invitationId);
        }

        function searchSellersByNameOrId(principalId, searchValue) {
            return PrincipalsDA.searchSellersByNameOrId(principalId, searchValue);
        }

        function searchBuyersByNameOrId(principalId, searchValue) {
            return PrincipalsDA.searchBuyersByNameOrId(principalId, searchValue);
        }

        function searchReports(principalId, searchData) {
            return PrincipalsDA.searchReports(principalId, searchData);
        }

        function downloadReportFile(auditId, format) {
            return AuditDA.downloadReportFile(auditId, format);
        }

        function getReportFrequencies() {
            return angular.copy(PRINCIPAL.reportFrequencies);
        }

        function getInvitationReportErrorFrequencies() {
            return angular.copy(PRINCIPAL.invitationReportErrorFrequencies);
        }

        function getSellerReferentialSendingFrequencies() {
            return angular.copy(PRINCIPAL.invitedSellersReferentialSendingFrequencies);
        }

        function getSellerListFilter() {
            return $sessionStorage.sellerListFilter;
        }

        function getBuyerListFilter() {
            return $sessionStorage.buyerListFilter;
        }

        function getPrincipalListFilter() {
            return $sessionStorage.principalListFilter;
        }

        function getCompanyListFilter() {
            return $sessionStorage.companyListFilter;
        }

        function getContainerListFilter() {
            return $sessionStorage.containerListFilter;
        }

        function initPrincipalListStorage() {
            $sessionStorage.$reset({ principalListFilter: null });
            $sessionStorage.$reset({ companyListFilter: null });
            $sessionStorage.$reset({ containerListFilter: null });
        }
        /**
         * Retourne True si la société est supprimable.
         * @param legalEntityId Identifiant de la société
         */
        function isCompanyDeletable(legalEntityId) {
            return LegalEntityDA.isCompanyDeletable(legalEntityId);
        }

        /**
         * Supprime une société vide.
         * @param legalEntityId Identifiant de la société
         */
        function deleteCompany(legalEntityId) {
            return LegalEntityDA.deleteCompany(legalEntityId);
        }

        function initSellerFilterSessionStorage() {
            $sessionStorage.sellerListFilter = null;
        }

        function initBuyerFilterSessionStorage() {
            $sessionStorage.buyerListFilter = null;
        }

        /**
         * Retourne True si le donneur d'ordre est supprimable.
         * @param principalId Identifiant du DO
         */
        function isPrincipalDeletable(principalId) {
            return PrincipalsDA.isPrincipalDeletable(principalId);
        }

        /**
         * Supprime le DO vide.
         * @param Identifiant du DO
         */
        function deletePrincipal(principalId) {
            return PrincipalsDA.deletePrincipal(principalId);
        }

        /**
         * Cherche les groupes du DO suivant des critères.
         *
         * @param principalId Identifiant du DO
         * @param criteria Critères de recherche
         */
        function searchGroups(principalId, criteria) {
            var promise = PrincipalsDA.searchGroups(principalId, criteria);

            // Place le groupe par défaut en début de liste
            promise.then(groups =>
                groups.sort((a, b) => {
                    if (a.type === 'ALL') return -1;
                    if (b.type === 'ALL') return 1;
                    return 0;
                })
            );

            return promise;
        }

        /**
         * Créé un nouveau groupe.
         *
         * @param principalId Identifiant du DO
         * @param criteria détails du groupe
         */
        function createGroup(principalId, criteria) {
            return PrincipalsDA.createGroup(principalId, criteria);
        }

        /**
         * Modifie un groupe.
         *
         * @param principalId Identifiant du DO
         * @param groupId Identifiant du groupe à modifier
         * @param criteria détails du groupe
         */
        function updateGroup(principalId, groupId, criteria) {
            return PrincipalsDA.updateGroup(principalId, groupId, criteria);
        }

        /**
         * Recherche des utilisateurs
         *
         * @param {Object} usersFilter - Critères de recherche
         */
        function searchUsers(principalId, usersFilter) {
            // Supprime les 'ALL' pour le role et le status (clone le filtre pour ne pas l'impacter)
            var filter = usersFilter.preparBeforeSearch();
            return PrincipalsDA.searchUsers(principalId, filter);
        }

        /**
         * Sauvegarde d'un utilisateur.
         */
        function createPrincipalAdmin(principalId, user) {
            this.authorization = new LegalEntityGroupUser();
            return this.searchGroups(principalId, {}).then(groups => {
                this.authorization.legalEntityGroup = groups[0];
                this.authorization.role = 'ADMIN_FO';
                user.legalEntityGroupUsers.push(this.authorization);
                this.admin = null;
                return PrincipalsDA.saveUser(principalId, user);
            });
        }

        /**
         * Sauvegarde d'un utilisateur.
         */
        function saveUser(principalId, user) {
            return PrincipalsDA.saveUser(principalId, user);
        }

        /**
         * Nous dit si un utilisateur est l'unique admin d'un donneur d'ordres.
         * @param {number} principalId - identifiant du donneur d'ordres.
         * @param {string} userId - login de l'utisateur
         */
        function isUserSingleAdminFo(principalId, userId) {
            return PrincipalsDA.isUserSingleAdminFo(principalId, userId);
        }

        /**
         * Indique si l'entreprise a des fournisseurs en cours d'invitation
         * @param principalId Identifiant de l'entreprise
         */
        function hasSellerInvited(principalId) {
            return PrincipalsDA.hasSellerInvited(principalId);
        }

        /**
         * Permet de recuperer toutes les etabisements d'DO
         * @param {*} data
         */
        function autoCompleteGetAllSubEntityDOPermiter(data) {
            return PrincipalsDA.autoCompleteGetAllSubEntityDOPermiter(data);
        }

        /**
         * Récupération des établissements.
         */
        function getSubEntities(legalEntityId) {
            return SellersDA.getSubEntities(legalEntityId);
        }

        /**
         * Récupération des divisions.
         */
        function getDivisions(legalEntityId) {
            return SellersDA.getDivisions(legalEntityId);
        }

        /**
         *  Liste les sociétés associées à un donneur d'ordre.
         */
        function listCompanies(principalId) {
            return PrincipalsDA.listCompanies(principalId);
        }

        /**
         * Permet la creation d'un groupe d'etablisment
         * @param {*} data
         */
        function createGroupSubEntity(data) {
            return PrincipalsDA.createGroupSubEntity(data);
        }

        /**
         * Permet la Mise a jour d'un groupe d'etablisment
         * @param {*} data
         */
        function updateGroupSubEntity(data) {
            return PrincipalsDA.updateGroupSubEntity(data);
        }

        function checkGisPlatformId(legalEntity, principalId) {
            return PrincipalsDA.checkGisPlatformId(legalEntity, principalId);
        }

        function checkGisCompanyDetail(platformEid, codeDO) {
            return PrincipalsDA.checkGisCompanyDetail(platformEid, codeDO);
        }

        /**
         * Récupération des références workflow à partir de l'Id métier du DO
         */
        function getWorkflowReferences(principalEid) {
            return WorkflowDA.getThreeWayReferences(principalEid);
        }

        function getSubEntity(id) {
            return PrincipalsDA.getSubEntity(id);
        }

        function getCgvOfSubEntity(id) {
            return PrincipalsDA.getCgvOfSubEntity(id);
        }

        function getCgvPdf(id) {
            return PrincipalsDA.getCgvPdf(id);
        }

        function uploadCgvPdf(document, subEntityId) {
            return PrincipalsDA.uploadCgvPdf(document, subEntityId);
        }

        function deleteCgvDoc(documentId) {
            return PrincipalsDA.deleteCgvDoc(documentId);
        }

        function updateSubEntity(subEntityDto) {
            return PrincipalsDA.updateSubEntity(subEntityDto);
        }
        function createSubEntity(subEntityDto,legalEntityId) {
            return PrincipalsDA.createSubEntity(subEntityDto,legalEntityId);
        }

        /**
         * Récupération de la personalisation du DO
         */
        function getBrand(principalId) {
            return PrincipalsDA.getBrand(principalId);
        }

        function exportInvitedBuyersFollowUp(principalId, onlyNullEmails) {
            return PrincipalsDA.exportInvitedBuyersFollowUp(principalId, onlyNullEmails);
        }

        function countInvitedBuyersFollowUpNotifiedWithDate(principalId) {
            return PrincipalsDA.countInvitedBuyersFollowUpNotifiedWithDate(principalId);
        }
        function getSubEntityRejectionInfo(subEntityId) {
            return LegalEntityDA.getSubEntityRejectionInfo(subEntityId);
        }

        function exportConfDo(principalId, modulesToExport) {
            return PrincipalsDA.exportConfDo(principalId, modulesToExport);
        }

        function checkImportConfDo(zipFile) {
            return PrincipalsDA.checkImportConfDo(zipFile);
        }
        /**
         * Import d'un donneur d'ordre
         *
         * @param {Object} principal - les donneur d'ordre composé d'un PrincipalDetail, un PrincipalKiss et un PrincipalEpdf
         * @param {Object} admin - l'administrateur à créer si nécessaire
         */

        function importConfDo(resultImportDto) {
            return PrincipalsDA.importConfDo(resultImportDto);
        }

        /**
         * Indique si le DO  fournisseur (process O2C activé) peut avoir le role Administrateur des ventes
         * @param principalId Identifiant du DO
         */
        function canHaveSalesAdmin(principalId) {
            return PrincipalsDA.canHaveSalesAdmin(principalId);
        }

        /**
         * Récupère la liste des référentiels data repo d'un DO
         * @param querySearchCriteria contient idenfiant d'un DO
         */
        function getAllReferentialsOfPrincipal(querySearchCriteria) {
            return PrincipalsDA.getAllReferentialsOfPrincipal(querySearchCriteria);
        }

        /**
         * Enregistrer la liste des référentiels data repo d'un DO
         * @param querySearchCriteria contient idenfiant d'un DO
         * @param referentials liste des référentiels
         */
        function saveAllReferentials(principalId, referentials) {
            return PrincipalsDA.saveAllReferentials(principalId, referentials);
        }

        /**
         * Récupère la liste des communautés pour lesquelles les sociétés DO adhèrent
         * @param companyIds Ids des sociétés DO
         * @param principalId Id DO
         */
        function findReferentialsOfCommunitiesByIds(principalId, companyIds) {
            return PrincipalsDA.findReferentialsOfCommunitiesByIds(principalId, companyIds);
        }

        /**
         * Récupération des espaces documentaire du DO
         */
        function getDocumentarySpace(principalId) {
            return PrincipalsDA.getDocumentarySpace(principalId);
        }

        /**
         * vérification et création de l'espace documentaire du DO
         * @param principalId Id DO
         * @param documentarySpace l'objet documentarySpace ( typeCode, typeLabel, id , desc )
         * @param doCheckCompaniesDocumentarySpace boolean qui indique s'il faut vérifier si les sociétés du DO ont un espace documentaire
         */
        function checkAndSaveDocumentarySpace(principalId, documentarySpace, doCheckCompaniesDocumentarySpace) {
            return PrincipalsDA.checkAndSaveDocumentarySpace(
                principalId,
                documentarySpace,
                doCheckCompaniesDocumentarySpace
            );
        }

        /**
         * mettre à jour l'espace documentaire du DO
         * @param principalId Id DO
         * @param documentarySpace l'objet documentarySpace ( typeCode, typeLabel, id , desc )
         */
        function updateDocumentarySpace(principalId, documentarySpace) {
            return PrincipalsDA.updateDocumentarySpace(principalId, documentarySpace);
        }

        /**
         * supprimer l'espace documentaire du DO
         * @param principalId Id DO
         * @param documentarySpace l'objet documentarySpace ( typeCode, typeLabel, id , desc )
         */
        function deleteDocumentarySpace(principalId, documentarySpace) {
            return PrincipalsDA.deleteDocumentarySpace(principalId, documentarySpace);
        }

        /**
         * Détache une société du DO.
         * @param principalId   Identifiant du DO
         * @param companyId     Identifiant de la société
         */
        function companySignOut(principalId, companyId){
            return PrincipalsDA.companySignOut(principalId, companyId);
        }

        /**
         * Retourne toutes les plateformes de démat disponibles.
         */
        function getAllDematPlatforms() {
            return PrincipalsDA.getAllDematPlatforms();
        }

        function getGroup(principalId, groupId) {
            return PrincipalsDA.getGroup(principalId, groupId);
        }

        function getLegalEntityAndSubEntityForGroup(groupId) {
            return PrincipalsDA.getLegalEntityAndSubEntityForGroup(groupId);
        }

       function getOffresApi(principalId){
            return PrincipalsDA.getOffresApi(principalId);
       }

        function addOfferApi(principalId,offresApiConfig){
            return PrincipalsDA.addOfferApi(principalId,offresApiConfig);
        }

        function getOffresApiForLegalEntity(principalId,offresApiConfig){
            return PrincipalsDA.getOffresApiForLegalEntity(principalId,offresApiConfig);
        }

        function getGroupTitle(group) {
            if (group && group.nbDivisions > 0) {
                return 'Liste des divisions - ' + group.name;
            } else if (group && group.nbSubEntities > 0) {
                return 'Liste des établissements - ' + group.name;
            }
            return 'Liste des sociétés - ' + group.name;
        }

        function getGroupColumns(group) {
            const countryCellTemplate =
                '<div class="ui-grid-cell-contents">{{"country." + COL_FIELD | lowercase | translate}}</div>';
            if (group && group.nbDivisions > 0) {
                return [
                    { name: 'name', displayName: 'Nom Division', sort: { direction: 'asc', priority: 0 } },
                    { name: 'code', displayName: 'ID Division' },
                    { name: 'countryCode', displayName: 'Pays', cellTemplate: countryCellTemplate },
                ];
            } else if (group && group.nbSubEntities > 0) {
                return [
                    { name: 'name', displayName: 'Nom Etablissement', sort: { direction: 'asc', priority: 0 } },
                    { name: 'code', displayName: 'ID Etablissement' },
                    { name: 'getTypeLabel()', displayName: 'Type Etablissement' },
                    { name: 'countryCode', displayName: 'Pays', cellTemplate: countryCellTemplate },
                ];
            } else {
                return [
                    { name: 'name', displayName: 'Raison Sociale', sort: { direction: 'asc', priority: 0 } },
                    { name: 'idFiscal', displayName: 'ID Fiscal' },
                    { name: 'idNational', displayName: 'ID Légal' },
                    { name: 'countryCode', displayName: 'Pays', cellTemplate: countryCellTemplate },
                ];
            }
        }

        function getGroupData(principalDetailId, authorization, group) {
            if (group && (group.nbDivisions > 0 || group.nbSubEntities > 0)) {
                return this.getLegalEntityAndSubEntityForGroup(authorization.legalEntityGroup.id).then(
                    data => data.subEntities
                );
            } else {
                return this.getGroup(principalDetailId, authorization.legalEntityGroup.id).then(data => data.companies);
            }
        }
        function createOrUpdatePdp(legalEntitiesIdsPdp,sens) {
            return PrincipalsDA.createOrUpdatePdp(legalEntitiesIdsPdp,sens);
        }

        function createOrUpdateSubEntPdp(legalEntitiesIdsPdp) {
            return PrincipalsDA.createOrUpdateSubEntPdp(legalEntitiesIdsPdp);
        }

        function createOrUpdateRoutingCodePdp(routingCodesIdsPdp) {
            return PrincipalsDA.createOrUpdateRoutingCodePdp(routingCodesIdsPdp);
        }

        function checkFacturXExchangeDirectoryExistence(platformPathFacturX) {
            return PrincipalsDA.checkFacturXExchangeDirectoryExistence(platformPathFacturX);
        }

        function downloadClientResourceVersion(resourceUUID) {
            return PrincipalsDA.downloadClientResourceVersion(resourceUUID);
        }

        function deleteClientResourceVersion(resourceUUID,deleteRequest) {
            return PrincipalsDA.deleteClientResourceVersion(resourceUUID,deleteRequest);
        }

        function uploadAndDeployClientResource(uploadRequest) {
            return PrincipalsDA.uploadAndDeployClientResource(uploadRequest);
        }

        function getClientResourceVersions(getRequestDto) {
            return PrincipalsDA.getClientResourceVersions(getRequestDto);
        }

        function getAcquittal(principalId){
            return PrincipalsDA.getAcquittal(principalId);
        }

        function addAcquittal(acquittalConfigDo,acquittalConfig){
            return PrincipalsDA.addAcquittal(acquittalConfigDo,acquittalConfig);
        }

        function getLegalEntityContext(principalId,fluxType){
            return PrincipalsDA.getLegalEntityContext(principalId,fluxType);
        }

        function addAcquittalForLegalEntity(acquittalConfigDo,acquittalConfig){
            return PrincipalsDA.addAcquittalForLegalEntity(acquittalConfigDo,acquittalConfig);
        }
    }
})();
